<!--
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2018-12-21 17:02:06
 * @LastEditors: wjx
 * @LastEditTime: 2019-07-17 10:42:57
 -->
<template>
  <div class="headline_box">
    <dial
      :argotDialShow.sync="argotDialShow"
      :argotDialresData.sync="argotDialresData"
    ></dial>
    <iframe
      style="min-height:600px"
      width="100%"
      ref="contentIframe"
      id="show-iframe"
      frameborder="0"
      name="showHere"
      scrolling="auto"
      :src="iframeUrl"
      v-if="iframeUrl"
      @load="loaded"
    ></iframe>
    <!-- <div class="" v-html="detailObj.content">

    </div>-->
    <div class="hasPadding" style="padding-bottom: 2rem">
      <!-- <x-button v-if="showSub && detailObj.type != 2 && detailObj.type != 1" type="primary" @click.native="subInformationRelationDepartment">
                订阅
      </x-button>-->
      <div v-if="listData">
        <h5 class="pTitle">相关阅读</h5>
        <list-for-img-and-text
          :list="listData"
          @headlineItemChange="headlineItemChange"
        ></list-for-img-and-text>
      </div>
      <div v-if="relationCourseItems">
        <h5 class="pTitle" style="margin-top:.2rem ">相关课程</h5>
        <course-list
          :show-icon="true"
          :list="relationCourseItems"
        ></course-list>
      </div>
      <div v-if="tabList && tabList.length">
        <h5 class="pTitle" style="margin:.2rem 0; ">相关话题</h5>
        <Tabs :list="tabList"></Tabs>
      </div>

      <comment
        v-if="wxUserInfo.userDataStatus"
        @event-collection="eventCollection"
        :is-collection="isCollection"
        :qa-id="detailObj.id"
        :type="commentType"
        :name="detailObj.title"
        :editor="detailObj.editor"
      ></comment>
    </div>
    <img
      :style="{ left: btStyle.left, top: btStyle.top }"
      v-if="isArgotInfo"
      @click="dialogEvent"
      class="argot-bt"
      ref="argot-bt"
      src="http://cdn.yxvzb.com/WEB/wx-master/images/anyu/bt.png"
      alt
    />
  </div>
</template>
<script>
import ListForImgAndText from '@/components/Headline/list.vue';
import dial from '../components/dial.vue';
import Tabs from '@/components/Headline/Tabs.vue';

import { headline, shareCallback, getChannelById } from '@/api/ajax.js';
import comment from '@/components/Comment/index.vue';
import CourseList from '@/components/Course/SmailList.vue';
// TODO: vux
import {
  Confirm,
  XDialog,
  TransferDomDirective as TransferDom,
  XButton
} from 'vux';
import { mapState, mapActions } from 'vuex';
import { contentview } from '@/Mixin/contentview.js';
// todo 限制了是否显示论评 模拟落地分享也
// todo 推荐视频 已注释
export default {
  name: '',
  mixins: [contentview],
  directives: {
    TransferDom
  },
  data() {
    return {
      iframeUrl: '',
      detailObj: {},
      categoriesArr: [],
      listData: null,
      tabList: null, // 话题标签
      relationCourseItems: null,
      showSub: true, //  详情中的订阅
      showToPushInfo: false, // 用户内的订阅
      showBigPushInfo: false, // 订阅大弹层
      agin: false,
      isCollection: 0,
      inApp: false,
      isArgotInfo: false, // 是否为暗语资讯
      argotText: '', // 暗语
      showDialog: false,
      btStyle: {
        left: '-100px',
        top: '-100px'
      },
      argotDialShow: false, // 控制抽奖显示
      showType: -1, // 抽奖结果类型  1 未抽奖  2 暗语 3 积分 4 下次
      argotDialresData: {},
      commentType: 3 // 评论类型  2:病例 3:资讯 ,5:直播 ,6:录播,7:点赞 8:用户帖子
    };
  },
  methods: {
    ...mapActions(['wxUserInfoAction']),
    dialogEvent() {
      let wxOpenId = this.wxUserInfo.wxOpenId;
      // this.showDialog = true

      // 点击埋点
      this.$sa.re_activity({
        name: '暗语红包活动',
        event_type: '点击',
        target_name: '查看暗语'
      });

      let respFunc = (integral, money) => {
        if (integral) {
          return 3;
        } else if (watchword) {
          return 2;
        } else {
          return 4;
        }
      };
      // 查看是否抽过
      headline
        .ifPrizeDraw({
          wxOpenId
        })
        .then(res2 => {
          // let { isDrawed } = res2.data
          //
          // // 未抽奖
          // if(isDrawed === '0'){
          //   console.log('=-=-=')
          //   this.showType = 1
          //   // 获取结果
          //   // headline.drizeDraw({
          //   //   wxOpenId
          //   // }).then(res3 => {
          //   //   let {integral,money } = res2.data
          //   //
          //   // })
          // }else{  // 已抽奖
          //     let {integral,money } = res2.data
          //
          // }
          this.argotDialresData = res2.data;
          this.argotDialShow = true;
        });
    },
    eventCollection(val) {
      this.isCollection = val;
    },
    getArgot() {
      let infomationId = this.$route.params.id;
      if (infomationId) {
        headline
          .judgeWatchwordInfo({
            informationId: infomationId,
            wxOpenId: this.wxUserInfo.wxOpenId
          })
          .then(res => {
            let isWatchword = res.data.isWatchword;
            let activityWatchword = res.data.activityWatchword;
            if (isWatchword === '1') {
              this.isArgotInfo = true;

              // headline.obtainWatchword({
              //     wxOpenId: this.wxUserInfo.wxOpenId
              // }).then(res2 => {
              //
              //     this.argotText = res2.data.watchword;
              //
              //
              // })
            }
            if (activityWatchword === '1') {
              // 点击埋点
              this.$sa.re_activity({
                name: '暗语红包活动',
                event_type: '进入'
              });
            }
          });
      }
    },
    getDetail() {
      this.getArgot();
      let detailType = this.$route.query.type;
      let data = {
        id: this.$route.params.id,
        type: detailType
      };
      let request = 'detail';

      if (detailType == 2) {
        request = 'caseDetail';
      } else if (detailType == 8) {
        request = 'noteDetail';
      }
      headline[request](data).then(res => {
        let respData = res.data.data;
        // TODO: 相关话题
        // this.categoriesArr = this.$api.categoriesFilter(respData.categories)

        this.tabList = respData.noteTopic;
        this.detailObj = respData.detail;
        let iframeUrlSplit = this.detailObj.content.split('?');
        if (iframeUrlSplit.length > 1) {
          // https 转 http
          this.detailObj.content =
            (this.$config.protocol === 'https'
              ? iframeUrlSplit[0].replace(/http:/g, 'https:')
              : iframeUrlSplit[0]) +
            '?t=' +
            new Date().getTime();
        }
        this.headlineItemChange(this.detailObj.content);
        // this.detailObj.type != 2 ? this.showBigPushInfo = true : this.showBigPushInfo = false
        this.listData = respData.relationNews;
        this.relationCourseItems = respData.relationCourse;

        this.isCollection = respData.subscribe ? 1 : 0;
        // 暂时去掉 是否订阅
        this.showSub = !respData.ifSubscribe;
        let wxUserInfo = this.$api.getStorage('wxUserInfo') || {};
        let shareFlag = 'wx';
        let shareType = 'information';
        if (/shareFlag=true/.test(location.href)) {
          shareFlag = 'share';
        }
        if (this.$route.query.type == 2) {
          shareType = 'bingli';
        } else if (this.$route.query.type == 8) {
          shareType = 'tiezi';
        }
        sa.track(
          'caseDetail',
          {
            title: this.detailObj.title,
            type: shareType,
            pageUrl: location.href,
            from: shareFlag,
            editor: this.detailObj.editor || '',
            client_id: wxUserInfo.id || wxUserInfo.wxOpenId || '',
            distinctId: wxUserInfo.id || wxUserInfo.wxOpenId || '',
            web_edition: 2
          },
          function() {}
        );
        let newScType = '资讯';
        if (shareType == 'tiezi') {
          newScType = '帖子';
        } else if (shareType == 'bingli') {
          newScType = '病例';
        }
        this.pageStayTime(newScType);
        let oIframe = document.getElementById('show-iframe');
        let deviceWidth = document.documentElement.clientWidth;
        let deviceHeight = document.documentElement.clientHeight;
        // oIframe.style.width = '10rem';
        // oIframe.style.height = deviceHeight + 'px';
        //          oIframe.style.height = oIframe.contentDocument.body.scrollHeight+'px'

        /*
         * 分享
         * */
        let shareCallBackFunc = () => {
          shareCallback().then(res => {
            if (res.data.data.number == 5) {
              // 更改后恭喜您分享成功,获得3积分 每天前3次分享均可获得5积分
              this.$vux.toast.show({
                text: '恭喜您获得5积分',
                type: 'success',
                width: '5rem'
              });
            } else {
              // 您已获得今天全部分享 积分每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '分享成功!',
                type: 'success',
                width: '5rem'
              });
            }
            let wxUserInfo = this.$api.getStorage('wxUserInfo');
            sa.track(
              'share_total',
              {
                from: 'wx',
                type: shareType,
                target: this.$route.params.id,
                client_id: wxUserInfo.id || wxUserInfo.wxOpenId || '',
                web_edition: 2
              },
              function() {}
            );

            // 分享埋点
            this.$sa.re_interaction({
              type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
              contentype: this.$route.query.type || 3, // 互动主体 直播，录播，资讯，病例，站内信，论坛
              contentid: this.$route.params.id, // 内容id
              first_cate: '', // 一级分类
              second_cate: '', // 2级分类
              first_cate_id: '', // 1级分类id
              second_cate_id: '', // 2级分类id
              author: this.detailObj.editor || '', // 讲师/作者
              contentname: this.detailObj.title,
              zone_name: this.$route.query.source_user_id
                ? ''
                : this.zone_name || '', // 来源专区
              zone_id: this.$route.query.source_user_id
                ? ''
                : this.$route.query.zone_id || '', // 来源专区
              source_user_id: this.$route.query.source_user_id || '' // 邀请人ID
              // location:'', //位置 站内，专区内，超级面对面内
            });
          });
        };
        let shareUrl = location.href;
        if (!this.$route.query.shareFlag) {
          let splitUrlForHeaderDetail = shareUrl.split('headlineDetail/')[0];
          let shareQuery = '?shareFlag=true';
          let { zone_id, type, source_user_id, isTemp } = this.$route.query;
          if (type) {
            shareQuery += `&type=${type}`;
          }
          if (zone_id) {
            shareQuery += `&zone_id=${zone_id}&source_user_id=${source_user_id ||
              this.wxUserInfo.shenceId}`;
          }
          if (isTemp) {
            shareQuery += `&isTemp=${isTemp}`;
          }
          splitUrlForHeaderDetail += `headlineDetail/${this.$route.params.id}${shareQuery}`;
          shareUrl = splitUrlForHeaderDetail;
          // if(splitUrlForHeaderDetail.length > 2) {
          //   shareUrl = shareUrl.replace('?shareFlag=true', '&shareFlag=true')
          // }else {
          //   shareUrl = shareUrl + `${this.$route.query.type || this.$route.query.isTemp ? '&' : '?'}shareFlag=true`
          // }
        }
        let sharePic =
          this.detailObj.converUrl ||
          'http://cdn.yxvzb.com/newWechat/image/logo98.png';
        if (this.$route.query.zone_id) {
          getChannelById({
            channelId: this.$route.query.zone_id
          }).then(res => {
            this.zone_name = res.data.data;
            this.$wxShareInfo(
              this.detailObj.title,
              this.detailObj.introduces,
              sharePic,
              location.href,
              shareUrl,
              shareCallBackFunc
            );
          });
        } else {
          this.$wxShareInfo(
            this.detailObj.title,
            this.detailObj.introduces,
            sharePic,
            location.href,
            shareUrl,
            shareCallBackFunc
          );
        }
      });
    },
    loaded() {
      setTimeout(() => {
        let oIframe = document.getElementById('show-iframe');
        // oIframe.contentDocument.body.scrollTop oIframe.contentWindow.document.documentElement.scrollHeight 不会计算重载的高度
        let iframeBodyHeight =
          Math.max(oIframe.contentWindow.document.body.scrollHeight) + 'px';
        // 获取IFRAME内容高度
        // oIframe.contentDocument.body.style.width = '9rem'
        console.log(oIframe.contentWindow.document.body.scrollHeight);
        console.log(
          oIframe.contentWindow.document.documentElement.scrollHeight
        );
        oIframe.contentDocument.body.style.margin = 'auth';
        oIframe.style.height = 'auto';
        oIframe.style.height = iframeBodyHeight;
        // oIframe.setAttribute("height", iframeBodyHeight);
        oIframe.contentDocument.body.style.overflowX = 'hidden';
        if (this.$api.kernel() == 'wx') {
          setTimeout(() => {
            this.btStyle = {
              left: Math.floor(Math.random() * 9) + 'rem',
              top:
                Math.floor(
                  Math.random() * (parseInt(oIframe.style.height) - 200)
                ) +
                200 +
                'px'
            };
          }, 800);
          try {
            oIframe.contentWindow.document.querySelector(
              '.topWxLoad'
            ).onclick = function() {
              window.location.href =
                'http://cdn.yxvzb.com/WEB/static-html/downloadApp.html?qudao=beiyong1';
            };
          } catch (e) {
            console.log('IFRAME事件未绑定');
          }
        }
      });
    },
    randomFunc(oIframe) {
      let loopDom = index => {
        if (!elementPs[index].textContent) {
          loopDom(index + 1);
        } else {
          return index;
        }
      };
      let elementPs = oIframe.contentWindow.document.querySelectorAll(
        '.contentText p'
      );
      let len = elementPs.length;

      // 舍掉最后一个（文章公告）
      let randomIframeInitIndexP = Math.floor(Math.random() * (len - 1));
      let domIndex = loopDom(randomIframeInitIndexP);
      // console.log(domIndex, elementPs[domIndex].textContent.length)
      for (let i = 0; i < len - 2; i++) {
        // console.log(elementPs[i].textContent)
      }
    },
    fetchData() {
      this.getDetail();
    },
    subInformationRelationDepartment() {
      // 订阅按钮
      headline
        .subInformationRelationDepartment({
          id: this.$route.params.id
        })
        .then(res => {
          this.showSub = false;
          this.$vux.toast.show({
            text: '订阅成功',
            type: 'success',
            width: '5rem'
          });
        });
    },
    setIframeUrl(type, id, url) {
      let name = 'info';
      if (type == 2) {
        name = 'case';
      } else if (type == 8) {
        name = 'note';
      }
      // 拼接
      // this.iframeUrl = `http://cdn.yxvzb.com/static/content/${name}/${id}.html`
      // this.iframeUrl = 'http://ysh-wxv2.jimijiayuan.cn/html/t/67961.html'
    },
    headlineItemChange(item) {
      // 先重置，不然iframe计算错误
      this.iframeUrl = '';
      try {
        let oIframe = document.getElementById('show-iframe');
        oIframe.style.height = 'auto';
      } catch (e) {}

      // string url 直接赋值
      if (typeof item === 'string') {
        this.iframeUrl = item;
      }
      // 防止接口慢，iframe 拼接加载，由于无法控制是否该显示，暂时干掉
      // this.setIframeUrl(item.type, item.id)
      // this.iframeUrl = 'http://ysh-wxv2.jimijiayuan.cn/html/t/68434.html'
    }
    // toPushInfo(){ //浮层订阅
    //
    //   headline.toPushInfo({userId: this.wxUserInfo.id, status: this.agin ? 0 : 1}).then(res => {
    //     this.showToPushInfo = false
    //     this.wxUserInfoAction(Object.assign(this.$api.getStorage('wxUserInfo'), {isRecieveInfoPush: 1}))
    //   })
    // },
    // onCancel(){
    //   this.showToPushInfo = false
    //   if (this.agin) {
    //     headline.toPushInfo({userId: this.wxUserInfo.id, status: this.agin ? 0 : 1}).then(res => {
    //       this.wxUserInfoAction(Object.assign(this.$api.getStorage('wxUserInfo'), {isRecieveInfoPush: 1}))
    //     })
    //   }
    // },
  },
  computed: {
    ...mapState({
      wxUserInfo: state => state.wxUserInfo
    })
  },
  components: {
    ListForImgAndText,
    comment,
    Confirm,
    XButton,
    CourseList,
    XDialog,
    Tabs,
    dial
  },
  watch: {
    $route: 'fetchData',
    wxUserInfo(val) {
      // val.isRecieveInfoPush == 1 ? this.showToPushInfo = false : this.showToPushInfo = true
    }
    //      ,
    //      $route: {
    //        handler: function (val, oldVal) {
    //          this.getDetail()
    //
    //        },
    //        deep: true
    //      }
  },
  created() {
    this.inApp = this.$api.isKln();
    this.commentType = this.$route.query.type || 3;
    // 防止接口慢，iframe 拼接加载
    // this.setIframeUrl(this.commentType, this.$route.params.id)

    this.getDetail();

    // 暴露 放大图片方法， 子集iframe调用
    let that = this;
    window.previewImageEvent = function(aa) {
      let ar = [];
      ar.push(aa);
      that.$wechat.previewImage({
        current: aa,
        urls: ar
      });
    };
  }
};
</script>
<style scoped lang="less">
@import '~vux/src/styles/close';
.pTitle {
  font-size: 0.3733rem;
}

.notPrompt {
}

.headline_box {
  width: 100%;
  .weui-btn_primary {
    background-color: #027cfa;
    padding: 0.2rem 0;
    margin: 0.2rem 0;
  }
}

.argot-bt {
  position: absolute;
  width: 1.8rem /* 130/75 */;
}

.argot-dialog-text {
  padding: 0.9rem 0;
  p {
    font-size: 0.4267rem /* 32/75 */;
  }
}
</style>
<style lang="less">
.headline_box {
  .weui-dialog {
    width: 85%;
    max-width: 95%;
    border-radius: 0.24rem; /* 18/75 */
  }
}
</style>
